import { http, HttpResponse } from 'msw';
import { PlessService } from '../../../app/shared/pless-service.model';
import { ResponseUtils } from '../response-utils';
import { SelectedGoodsFlgResultRequest, SelectedGoodsFlgResultResponse } from '../../../app/kymw/kymw70/kymw7002/api-service/get-selected-goods-flg-result.service';
import { GetApprovalFlowTypeInfoRequest, GetApprovalFlowTypeInfoResponse } from '../../../app/kymw/kymw70/kymw7002/api-service/get-approval-flow-type-info.service';
import { GetSuggestionGoodsListInfoRequest, GetSuggestionGoodsListInfoResponse } from '../../../app/kymw/kymw70/kymw7002/api-service/get-suggestion-goods-list-info.service';
import { GetCandidateSuggestionGoodsListRequest, GetCandidateSuggestionGoodsListResponse } from '../../../app/kymw/kymw70/kymw7002/api-service/get-candidate-suggestion-goods-list.service';
import { GetSuggestionGoodsInfoRequest, GetSuggestionGoodsInfoResponse } from '../../../app/kymw/kymw70/kymw7002/api-service/get-suggestion-goods-info.service';
import { RegistSuggestionGoodsInfoRequest } from '../../../app/kymw/kymw70/kymw7002/api-service/regist-suggestio-goods-info.service';
import { GetSuggestionGoodsListOutputInfoRequest, GetSuggestionGoodsListOutputInfoResponse } from '../../../app/kymw/kymw70/kymw7002/api-service/get-suggestion-goods-list-output-info.service';
import { PlessViewUtilsSub } from '../../../app/commons/kymw00/pless-view-utils-sub.service';

export const kymw70Handlers = [
  
  // 企画回コード取得 /kymw70/getDelivCatalogIdByOrderCode
  http.post(PlessService.SERVICE.getDelivCatalogIdByOrderCode.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.getDelivCatalogIdByOrderCode.url, req);
    return HttpResponse.json(getDelivCatalogIdByOrderCodeResponse);
    // return HttpResponse.json(getFeatureRequestListResponseEmpty);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // 受注コード取得 /kymw70/getOrderCodeByDelivCatalogId
  http.post(PlessService.SERVICE.getOrderCodeByDelivCatalogId.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.getOrderCodeByDelivCatalogId.url, req);
    return HttpResponse.json(getOrderCodeByDelivCatalogIdResponse);
    // return HttpResponse.json(getFeatureRequestListResponseEmpty);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // 受注コード部門リスト取得 /kymw70/getOrderCodeClassList
  http.post(PlessService.SERVICE.getOrderCodeClassList.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.getOrderCodeClassList.url, req);
    return HttpResponse.json(getOrderCodeClassListResponse);
    // return HttpResponse.json(getFeatureRequestListResponseEmpty);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // 受注コード媒体リスト取得 /kymw70/getOrderCodeMediumList
  http.post(PlessService.SERVICE.getOrderCodeMediumList.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.getOrderCodeMediumList.url, req);
    return HttpResponse.json(getOrderCodeMediumListResponse);
    // return HttpResponse.json(getFeatureRequestListResponseEmpty);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // 特集商品提案状況一覧取得 /kymw70/getFeatureRequestStatusList
  http.post(PlessService.SERVICE.getFeatureRequestStatusList.url, async ({ request }) => {
    const req = await request.json() as { data: object};
    console.log(PlessService.SERVICE.getFeatureRequestStatusList.url, req);
    return HttpResponse.json(getFeatureRequestStatusListResponse);
    // return HttpResponse.json(getFeatureRequestListResponseEmpty);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // 特集商品提案状況一覧取得 /kymw70/getFeatureRequestList
  http.post(PlessService.SERVICE.getFeatureRequestList.url, async ({ request }) => {
    const req = await request.json() as { data: object};
    console.log(PlessService.SERVICE.getFeatureRequestList.url, req);
    return HttpResponse.json(getFeatureRequestListResponse);
    // return HttpResponse.json(getFeatureRequestListResponseEmpty);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // 特集候補商品一覧情報取得 /kymw70/getFeatureCandidateGoodsList
  http.post(PlessService.SERVICE.getFeatureCandidateGoodsList.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.getFeatureCandidateGoodsList.url, req);
    return HttpResponse.json(getFeatureCandidateGoodsListResponse);
    // return HttpResponse.json(getFeatureCandidateGoodsListResponseEmpty);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // 特集候補商品一覧情報更新 /kymw70/updateFeatureRequestBuyer
  http.post(PlessService.SERVICE.updateFeatureRequestBuyer.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.updateFeatureRequestBuyer.url, req);
    return HttpResponse.json(updateFeatureRequestBuyerResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // 依頼先バイヤー取得 /kymw70/getRequestBuyer
  http.post(PlessService.SERVICE.getRequestBuyer.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.getRequestBuyer.url, req);
    return HttpResponse.json(getRequestBuyerResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // 依頼一覧情報取得（グループ長用） /kymw70/getRequestInfoList
  http.post(PlessService.SERVICE.getRequestInfoList.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.getRequestInfoList.url, req);
    return HttpResponse.json(getRequestListInfoResponse);
    // return HttpResponse.json(getRequestListInfoResponseEmpty);
        // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // 依頼一覧情報取得（担当バイヤー用） /kymw70/getRequestListInfo
  http.post(PlessService.SERVICE.getRequestListInfo.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.getRequestListInfo.url, req);
    return HttpResponse.json(getRequestListInfoResponse);
    // return HttpResponse.json(getRequestListInfoResponseEmpty);
        // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),
  
  // タグ一覧登録 /kymw70/updateFeatureRequestList
  http.post(PlessService.SERVICE.updateFeatureRequestList.url, async ({ request }) => {
    const req = await request;
    return HttpResponse.json(updateFeatureRequestListResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // 特集一覧取得 /kymw70/getFeatureList
  http.post(PlessService.SERVICE.getFeatureList.url, async ({ request }) => {
    const req = await request;
    return HttpResponse.json(getFeatureListResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // 特集一覧取得 /kymw70/getFeatureGoods
  http.post(PlessService.SERVICE.getFeatureGoods.url, async ({ request }) => {
    const req = await request;
    return HttpResponse.json(getFeatureGoodsResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // 特集一覧取得 /kymw70/getFeatureList
  http.post(PlessService.SERVICE.updateFeatureGoodsList.url, async ({ request }) => {
    const req = await request;
    return HttpResponse.json(updateFeatureGoodsList);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // KYMW7002: 商品選定済みフラグ確認結果取得処理 /kymw70/getSelectedGoodsFlgResult
  http.post(PlessService.SERVICE.getSelectedGoodsFlgResult.url, async ({ request }) => {
    const req = await request.json() as { data: SelectedGoodsFlgResultRequest };
    console.log(PlessService.SERVICE.getSelectedGoodsFlgResult.url, req);

    getSelectedGoodsFlgResultResponse.result.obj.OrderCode = req.data.search.SelectedGoodsFlgResult.condition.OrderCode ?? '';
    getSelectedGoodsFlgResultResponse.result.obj.MediumType = req.data.search.SelectedGoodsFlgResult.condition.MediumType ?? '';
    getSelectedGoodsFlgResultResponse.result.obj.FeatureCode = req.data.search.SelectedGoodsFlgResult.condition.FeatureCode ?? '';
    getSelectedGoodsFlgResultResponse.result.obj.SelectionFlg = '1';

    return HttpResponse.json(getSelectedGoodsFlgResultResponse);
  }),

  // KYMW7002: 承認フロー区分情報取得 /kymw70/getApprovalFlowTypeInfo
  http.post(PlessService.SERVICE.getApprovalFlowTypeInfo.url, async ({ request }) => {
    const req = await request.json() as { data: GetApprovalFlowTypeInfoRequest };
    console.log(PlessService.SERVICE.getApprovalFlowTypeInfo.url, req);

    return HttpResponse.json(getApprovalFlowTypeInfoResponse);
  }),

  // KYMW7002: 提案商品情報一覧取得処理 /kymw70/getSuggestionGoodsListInfo
  http.post(PlessService.SERVICE.getSuggestionGoodsListInfo.url, async ({ request }) => {
    const req = await request.json() as { data: GetSuggestionGoodsListInfoRequest };
    console.log(PlessService.SERVICE.getSuggestionGoodsListInfo.url, req);

    const maxCount = 312; // 最大返却件数を定義
    const countPerPage = 100; // ページ単位返却件数
    const totalPageNo = Math.ceil(maxCount / countPerPage); // 最大ページ数

    const pageNo = req.data.search.SuggestionGoodsList.condition.PageNo ?? 0;
    // 有効なページ番号なら返却リストを生成
    if (0 < pageNo && pageNo <= totalPageNo) {
      // 返却すべき要素数の範囲を決定
      const startIdx = (pageNo - 1) * countPerPage;
      const endCount = Math.min(startIdx + countPerPage, maxCount);
      // 返却リスト生成
      const list = Array.from({ length: (endCount - startIdx) }, (_, index) => (
        {
          PCode: `P${(startIdx + index + 1).toString().padStart(6, '0')}0`, // 「P＋ゼロ埋め7桁番号」を生成 (候補商品一覧と数値をズラすために1桁左シフト)
          ItemCode: Math.floor(Math.random() * 9000000 + 1000000).toString(), // ランダムな7桁の整数を生成
          JanCode: "1234567890123",
          GuideGoodsName: `手むき栗渋皮煮${(startIdx + index + 1)}`,
          GuideStandardName: "２２０ｇ",
          MakerName: "コープデリフーズ",
          PricePattern: String(Math.floor(Math.random() * 4)), // 0 - 3 のランダムな整数を生成
          SupplyPriceStandard: 1980.1,
          SupplyPriceSpecial1: 1981.2,
          SupplyPriceSpecial2: 1982.3,
          ThisTimeSupplyPriceStandard: 1680.4,
          CostPriceStandard: 1785.1,
          CostPriceSpecial1: 1781.2,
          CostPriceSpecial2: 1782.3,
          ThisTimeCostPriceStandard: 1480.4,
          StockNum: 482,
          OrderUnitType: "0",
          NewUnitType: "1",
          PlanNum: 500,
          OrderNum: "123456",
          Remarks: "備考テスト"
        }
      ));

      // レスポンス設定
      getSuggestionGoodsListInfoResponse.result.obj.TotalNum = String(maxCount);
      getSuggestionGoodsListInfoResponse.result.obj.StartDispNum = String(startIdx + 1);
      getSuggestionGoodsListInfoResponse.result.obj.EndDispNum = String(endCount);
      getSuggestionGoodsListInfoResponse.result.obj.SuggestionGoodsList = list;
    }

    return HttpResponse.json(getSuggestionGoodsListInfoResponse);
  }),

  // KYMW7002: 提案候補商品一覧情報取得処理 /kymw70/getCandidateSuggestionGoodsList
  http.post(PlessService.SERVICE.getCandidateSuggestionGoodsList.url, async ({ request }) => {
    const req = await request.json() as { data: GetCandidateSuggestionGoodsListRequest };
    console.log(PlessService.SERVICE.getCandidateSuggestionGoodsList.url, req);

    const listLength = 415; // 1000 を超えるとエラー
    const list = Array.from({ length: listLength }, (_, index) => (
      {
        PCode: `P${(index + 1).toString().padStart(7, '0')}`, // 「P＋ゼロ埋め7桁番号」を生成
        ItemCode: Math.floor(Math.random() * 9000000 + 1000000).toString(), // ランダムな7桁の整数を生成
        JanCode: "1234567890123",
        GuideGoodsName: `手むき栗渋皮煮${(index + 1)}`,
        GuideStandardName: "２２０ｇ",
        MakerName: "コープデリフーズ",
        EBaseSpecCode: "C111111-22223333-44445555",
        CatalogId: "2023年2月3回"
      }
    ));

    // レスポンス設定
    getCandidateSuggestionGoodsListResponse.result.obj.TotalNum = String(listLength);
    getCandidateSuggestionGoodsListResponse.result.obj.CandidateSuggestionGoodsList = list;

    return HttpResponse.json(getCandidateSuggestionGoodsListResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // KYMW7002: 提案商品情報取得処理 /kymw70/getSuggestionGoodsInfo
  http.post(PlessService.SERVICE.getSuggestionGoodsInfo.url, async ({ request }) => {
    const req = await request.json() as { data: GetSuggestionGoodsInfoRequest };
    console.log(PlessService.SERVICE.getSuggestionGoodsInfo.url, req);

    const goods = [] as GetSuggestionGoodsInfoResponse[];
    const combinations = req.data.search.SuggestionGoodsInfo.combination;
    for (const combination of combinations) {
      const pCode = combination.condition.PCode;
      goods.push({
        PCode: pCode,
        ItemCode: Math.floor(Math.random() * 9000000 + 1000000).toString(), // ランダムな7桁の整数を生成
        JanCode: "1234567890123",
        GuideGoodsName: "手むき栗渋皮煮 (候補から移動)",
        GuideStandardName: "２２０ｇ",
        MakerName: "コープデリフーズ",
        PricePattern: String(Math.floor(Math.random() * 4)), // 0 - 3 のランダムな整数を生成
        SupplyPriceStandard: 1980.1,
        SupplyPriceSpecial1: 1981.2,
        SupplyPriceSpecial2: 1982.3,
        ThisTimeSupplyPriceStandard: 1680.4,
        CostPriceStandard: 1780.1,
        CostPriceSpecial1: 1781.2,
        CostPriceSpecial2: 1782.3,
        ThisTimeCostPriceStandard: 1480.4,
        StockNum: 482,
        OrderUnitType: "0",
        NewUnitType: "1",
        PlanNum: 500,
        OrderNum: "123456",
        Remarks: "備考テスト (候補から移動)"
      });
    }
    getSuggestionGoodsInfoResponse.result.obj = goods;

    return HttpResponse.json(getSuggestionGoodsInfoResponse);
  }),

  // KYMW7002: 提案商品情報登録処理 /kymw70/registSuggestionGoodsInfo
  http.post(PlessService.SERVICE.registSuggestionGoodsInfo.url, async ({ request }) => {
    const req = await request.json() as { data: RegistSuggestionGoodsInfoRequest };
    console.log(PlessService.SERVICE.registSuggestionGoodsInfo.url, req);

    return HttpResponse.json(registSuggestionGoodsInfoResponse);
  }),

  // KYMW7002: 提案商品一覧出力情報取得処理 /kymw70/getSuggestionGoodsListOutputInfo
  http.post(PlessService.SERVICE.getSuggestionGoodsListOutputInfo.url, async ({ request }) => {
    const req = await request.json() as { data: GetSuggestionGoodsListOutputInfoRequest };
    console.log(PlessService.SERVICE.getSuggestionGoodsListOutputInfo.url, req);

    return HttpResponse.json(getSuggestionGoodsListOutputInfoResponse);
  }),
];

const responseStatusOnly = {
  status: 'ok',
  message: '処理完了',
}

const getDelivCatalogIdByOrderCodeResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: {
      DelivCatalogId: '20241000'
    }
  }
}

const getOrderCodeByDelivCatalogIdResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: {
      OrderCode: '2024100'
    }
  }
}

const getOrderCodeClassListResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: [
      {
        ClassCode: '01',
        ClassNameKanji: '農産',
      },
      {
        ClassCode: '02',
        ClassNameKanji: '水産',
      },
    ]
  }
}

const getOrderCodeMediumListResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: [
      {
        MediumType: '001',
        MediumName: 'ハピデリ',
      },
      {
        MediumType: '003',
        MediumName: 'ぐるめぐり',
      },
      {
        MediumType: "023",
        MediumTypeName: "コスメｄｅきれい（ＣＤ）"
      },
    ]
  }
}

const getFeatureRequestListResponseEmpty = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: []
  }
}

const getFeatureRequestStatusListResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: {
      // 特集商品提案状況一覧
      FeatureRequestStatusGoodsList: [
        {
          OrderCode: "2023230",
          CatalogIdName: "2023年08月01回",
          MediumType: "003",
          MediumName: "ぐるめぐり1",
          FeatureCode: "12345",
          FeatureName: "特集名テスト1",
          SelectionFlag: "0",
          Remarks: "備考テスト1"
        },
        {
          OrderCode: "2023230",
          CatalogIdName: "2023年08月02回",
          MediumType: "003",
          MediumName: "ぐるめぐり2",
          FeatureCode: "67890",
          FeatureName: "特集名テスト2",
          SelectionFlag: "0",
          Remarks: "備考テスト2"
        },
        {
          OrderCode: "2023230",
          CatalogIdName: "2023年08月03回",
          MediumType: "003",
          MediumName: "ぐるめぐり3",
          FeatureCode: "67890",
          FeatureName: "特集名テスト3",
          SelectionFlag: "0",
          Remarks: "備考テスト3"
        },
        {
          OrderCode: "2023230",
          CatalogIdName: "2023年08月04回",
          MediumType: "003",
          MediumName: "ぐるめぐり4",
          FeatureCode: "67890",
          FeatureName: "特集名テスト4",
          SelectionFlag: "0",
          Remarks: "備考テスト4"
        },
        {
          OrderCode: "2023230",
          CatalogIdName: "2023年08月05回",
          MediumType: "003",
          MediumName: "ぐるめぐり5",
          FeatureCode: "67890",
          FeatureName: "特集名テスト5",
          SelectionFlag: "1",
          Remarks: "備考テスト5"
        },
        {
          OrderCode: "2023230",
          CatalogIdName: "2023年08月06回",
          MediumType: "003",
          MediumName: "ぐるめぐり6",
          FeatureCode: "67890",
          FeatureName: "特集名テスト6",
          SelectionFlag: "1",
          Remarks: "備考テスト6"
        },
        {
          OrderCode: "2023230",
          CatalogIdName: "2023年08月07回",
          MediumType: "003",
          MediumName: "ぐるめぐり7",
          FeatureCode: "67890",
          FeatureName: "特集名テスト7",
          SelectionFlag: "1",
          Remarks: "備考テスト7"
        },
        {
          OrderCode: "2023230",
          CatalogIdName: "2023年08月08回",
          MediumType: "003",
          MediumName: "ぐるめぐり8",
          FeatureCode: "67890",
          FeatureName: "特集名テスト8",
          SelectionFlag: "2",
          Remarks: "備考テスト8"
        },
        {
          OrderCode: "2023230",
          CatalogIdName: "2023年08月09回",
          MediumType: "003",
          MediumName: "ぐるめぐり9",
          FeatureCode: "67890",
          FeatureName: "特集名テスト9",
          SelectionFlag: "2",
          Remarks: "備考テスト9"
        },
        {
          OrderCode: "2023230",
          CatalogIdName: "2023年08月10回",
          MediumType: "003",
          MediumName: "ぐるめぐり10",
          FeatureCode: "67890",
          FeatureName: "特集名テスト10",
          SelectionFlag: "2",
          Remarks: "備考テスト10"
        },
      ],
    },
  },
};

const getFeatureRequestListResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: [
      // 特集商品提案状況一覧
      {
        CatalogId: "20241114",  // 企画回
        SupplierNameKanji: "取引先名称（漢字）",  // 取引先名称（漢字）
        FeatureCode: "T1",  //  特集コード
        FeatureName: "取引先協賛企画",  // 特集名
        SelectionFlag: "2", // 商品選定済フラグ
        ReplacementStatus: "2",  // 付替ステータス
        OrderCode: "XXXXXXX", // 受注コード
        MediumType: "1" // 媒体区分
      },
      {
        CatalogId: "20241114",  // 企画回
        SupplierNameKanji: "取引先名称（漢字）",  // 取引先名称（漢字）
        FeatureCode: "T2",  //  特集コード
        FeatureName: "取引先協賛企画",  // 特集名
        SelectionFlag: "2", // 商品選定済フラグ
        ReplacementStatus: "2",  // 付替ステータス
        OrderCode: "XXXXXXX", // 受注コード
        MediumType: "2" // 媒体区分
      },
      {
        CatalogId: "20241113",  // 企画回
        SupplierNameKanji: "取引先名称（漢字）",  // 取引先名称（漢字）
        FeatureCode: "T1",  //  特集コード
        FeatureName: "取引先協賛企画",  // 特集名
        SelectionFlag: "2", // 商品選定済フラグ
        ReplacementStatus: "2",  // 付替ステータス
        OrderCode: "XXXXXXX", // 受注コード
        MediumType: "3" // 媒体区分
      },
      {
        CatalogId: "20241110",  // 企画回
        SupplierNameKanji: "取引先名称（漢字）",  // 取引先名称（漢字）
        FeatureCode: "T1",  //  特集コード
        FeatureName: "取引先協賛企画",  // 特集名
        SelectionFlag: "1", // 商品選定済フラグ
        ReplacementStatus: "1",  // 付替ステータス
        OrderCode: "XXXXXXX", // 受注コード
        MediumType: "1" // 媒体区分
      },
      {
        CatalogId: "20241110",  // 企画回
        SupplierNameKanji: "取引先名称（漢字）",  // 取引先名称（漢字）
        FeatureCode: "T2",  //  特集コード
        FeatureName: "取引先協賛企画",  // 特集名
        SelectionFlag: "2", // 商品選定済フラグ
        ReplacementStatus: "1",  // 付替ステータス
        OrderCode: "XXXXXXX", // 受注コード
        MediumType: "2" // 媒体区分
      },
      {
        CatalogId: "20241110",  // 企画回
        SupplierNameKanji: "取引先名称（漢字）",  // 取引先名称（漢字）
        FeatureCode: "T1",  //  特集コード
        FeatureName: "取引先協賛企画",  // 特集名
        SelectionFlag: "1", // 商品選定済フラグ
        ReplacementStatus: "1",  // 付替ステータス
        OrderCode: "XXXXXXX", // 受注コード
        MediumType: "3" // 媒体区分
      },
      {
        CatalogId: "20241109",  // 企画回
        SupplierNameKanji: "取引先名称（漢字）",  // 取引先名称（漢字）
        FeatureCode: "T1",  //  特集コード
        FeatureName: "取引先協賛企画",  // 特集名
        SelectionFlag: "2", // 商品選定済フラグ
        ReplacementStatus: "1",  // 付替ステータス
        OrderCode: "XXXXXXX", // 受注コード
        MediumType: "1" // 媒体区分
      },
      {
        CatalogId: "20241107",  // 企画回
        SupplierNameKanji: "取引先名称（漢字）",  // 取引先名称（漢字）
        FeatureCode: "T2",  //  特集コード
        FeatureName: "取引先協賛企画",  // 特集名
        SelectionFlag: "2", // 商品選定済フラグ
        ReplacementStatus: "2",  // 付替ステータス
        OrderCode: "XXXXXXX", // 受注コード
        MediumType: "2" // 媒体区分
      },
      {
        CatalogId: "20241107",  // 企画回
        SupplierNameKanji: "取引先名称（漢字）",  // 取引先名称（漢字）
        FeatureCode: "T1",  //  特集コード
        FeatureName: "取引先協賛企画",  // 特集名
        SelectionFlag: "2", // 商品選定済フラグ
        ReplacementStatus: "2",  // 付替ステータス
        OrderCode: "XXXXXXX", // 受注コード
        MediumType: "3" // 媒体区分
      },
    ],
  },
};

const getFeatureCandidateGoodsListResponseEmpty = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: []
  }
}

const getFeatureCandidateGoodsListResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: [
      {
        OrderCode: '2023340',
        MediumType: '001',
        MediumTypeName: 'ハピデリ',
        FeatureCode: '100H1',
        FeatureName: '表紙',
        ClassCode: '05',
        ClassCodeName: '菓子',
        MiddleClassCode: '4708',
        MiddleClassCodeName: '手土産菓子',
        PCode: 'P1234567',
        GuideGoodsName: 'ケーキ',
        GuideStandardName: '120g',
        ThisTimeSupplyPrice: 600,
        PricePattern: 3,
        PricePatternName: '特3',
        PlanNumAiPrediction: 2000,
        PlanNum: 1990,
        PlanSupplyBudget: 1200000,
        ThisTimeCostPrice: 450,
        Gpr: 50.0,
        RequestBuyerUserId: '0000001',
        RequestBuyerUserName: 'バイヤー1',
        Remarks: '備考1',
      },
      {
        OrderCode: '2023340',
        MediumType: '001',
        MediumTypeName: 'ハピデリ',
        FeatureCode: '100H2',
        FeatureName: '裏表紙',
        ClassCode: '05',
        ClassCodeName: '菓子',
        MiddleClassCode: '4602',
        MiddleClassCodeName: 'ポケット菓子',
        PCode: 'P1234567',
        GuideGoodsName: '菓子',
        GuideStandardName: '20g',
        ThisTimeSupplyPrice: 7000,
        PricePattern: 1,
        PricePatternName: '通常',
        PlanNumAiPrediction: 21000,
        PlanNum: 20000,
        PlanSupplyBudget: 12000000,
        ThisTimeCostPrice: 5600,
        Gpr: 75.5,
        RequestBuyerUserId: '0000002',
        RequestBuyerUserName: 'バイヤー2',
        Remarks: '備考2',
      },
      {
        OrderCode: '2023340',
        MediumType: '001',
        MediumTypeName: 'ハピデリ',
        FeatureCode: '100T1',
        FeatureName: 'お菓子特集',
        ClassCode: '05',
        ClassCodeName: '菓子',
        MiddleClassCode: '',
        MiddleClassCodeName: '',
        PCode: 'P1234567',
        GuideGoodsName: 'チョコ',
        GuideStandardName: '20g',
        ThisTimeSupplyPrice: 80000,
        PricePattern: 1,
        PricePatternName: '特1',
        PlanNumAiPrediction: 320000,
        PlanNum: 39000,
        PlanSupplyBudget: 120000000,
        ThisTimeCostPrice: 67000,
        Gpr: 99.9,
        RequestBuyerUserId: '0000003',
        RequestBuyerUserName: 'バイヤー3',
        Remarks: '備考3',
      },
    ],
  },
};

const updateFeatureRequestBuyerResponse = {
  status: 'ok',
  message: '処理完了',
};

const getRequestBuyerResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: [
      {
        RequestBuyerUserId: '0000001',
        RequestBuyerUserName: 'バイヤー1'
      },
      {
        RequestBuyerUserId: '0000002',
        RequestBuyerUserName: 'バイヤー2'
      },
      {
        RequestBuyerUserId: '0000003',
        RequestBuyerUserName: 'バイヤー3'
      },
    ]
  }
};

const getRequestListInfoResponseEmpty = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: []
  }
};

const getRequestListInfoResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: [
      {
        OrderCode: '2023340',
        MediumType: '001',
        MediumTypeName: '001:ハピデリ',
        BuyerRequestId: "0000000000001",
        RequestStatus: 0,
        RequestStatusName: '未依頼',
        RequestType: 0,
        RequestTypeName: '商品選定依頼',
        FeatureCode: '100H2',
        FeatureName: '裏表紙',
        ClassCode: '05',
        ClassCodeName: '菓子',
        MiddleClassCode: '4600',
        MiddleClassCodeName: 'チョコレート',
        PCode: 'P1234567',
        GuideGoodsName: 'チョコ',
        GuideStandardName: '120g',
        TagName: 'タグ2,タグ3',
        ThisTimeSupplyPrice: 5000,
        PricePattern: 1,
        PricePatternName: '特1',
        PlanNum: 4000,
        PlanSupplyBudget: 900000,
        ThisTimeCostPrice: 900,
        Gpr: 25.5,
      },
      {
        OrderCode: '2023340',
        MediumType: '001',
        MediumTypeName: 'ハピデリ',
        BuyerRequestId: "0000000000002",
        RequestStatus: 1,
        RequestStatusName: '未提案',
        RequestType: 1,
        RequestTypeName: '商品差替依頼',
        FeatureCode: '100T1',
        FeatureName: 'お菓子特集',
        ClassCode: '05',
        ClassCodeName: '菓子',
        MiddleClassCode: '4602',
        MiddleClassCodeName: 'ポケット菓子',
        PCode: 'P1234567',
        GuideGoodsName: '菓子',
        GuideStandardName: '20g',
        TagName: 'タグ4,タグ5,タグ6',
        ThisTimeSupplyPrice: 60000,
        PricePattern: 2,
        PricePatternName: '特2',
        PlanNum: 50000,
        PlanSupplyBudget: 1000000,
        ThisTimeCostPrice: 1000,
        Gpr: 25.5,
      },
      {
        OrderCode: '2023340',
        MediumType: '001',
        MediumTypeName: 'ハピデリ',
        BuyerRequestId: "0000000000003",
        RequestStatus: 2,
        RequestStatusName: '提案済',
        RequestType: 1,
        RequestTypeName: '商品差替依頼',
        FeatureCode: '100T1',
        FeatureName: 'お菓子特集',
        ClassCode: '05',
        ClassCodeName: '菓子',
        MiddleClassCode: '',
        MiddleClassCodeName: '',
        PCode: 'P1234567',
        GuideGoodsName: '菓子',
        GuideStandardName: '20g',
        TagName: 'タグ4,タグ5,タグ6',
        ThisTimeSupplyPrice: 60000,
        PricePattern: 2,
        PricePatternName: '特2',
        PlanNum: 50000,
        PlanSupplyBudget: 1000000,
        ThisTimeCostPrice: 1000,
        Gpr: 25.5,
      },
    ],
  },
};

const getSelectedGoodsFlgResultResponse: {
  status: string;
  message: string;
  result: { obj: SelectedGoodsFlgResultResponse }
} = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: {
      OrderCode: '', // リクエスト値を利用
      MediumType: '', // リクエスト値を利用
      FeatureCode: '', // リクエスト値を利用
      FeatureRequestId: '1234567890123',
      SelectionFlg: '0',
    }
  }
};

const getApprovalFlowTypeInfoResponse: {
  status: string;
  message: string;
  result: { obj: GetApprovalFlowTypeInfoResponse }
} = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: {
      ApprovalFlowType: '1',
    }
  }
};

const getSuggestionGoodsListInfoResponse: {
  status: string;
  message: string;
  result: { obj: GetSuggestionGoodsListInfoResponse }
} = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: {
      TotalNum: '0',
      StartDispNum: '0',
      EndDispNum: '0',
      SuggestionGoodsList: [],
    }
  }
};

const getCandidateSuggestionGoodsListResponse: {
  status: string;
  message: string;
  result: { obj: GetCandidateSuggestionGoodsListResponse }
} = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: {
      TotalNum: '0',
      CandidateSuggestionGoodsList: [],
    }
  }
};

const getSuggestionGoodsInfoResponse: {
  status: string;
  message: string;
  result: { obj: GetSuggestionGoodsInfoResponse[] }
} = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: [],
  }
};

const registSuggestionGoodsInfoResponse: {
  status: string;
  message: string;
} = {
  status: 'ok',
  message: '処理完了',
};

const getSuggestionGoodsListOutputInfoResponse: {
  status: string;
  message: string;
  result: { obj: GetSuggestionGoodsListOutputInfoResponse }
} = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: { FileName: 'xxx/xxx.text' },
  }
};

const updateFeatureRequestListResponse = {
  status: 'ok',
  message: '処理完了',
};

const getFeatureListResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: [
      // 特集商品提案状況一覧
      {
        FeatureCode: "T1",  //  特集コード
        FeatureName: "取引先協賛企画",  // 特集名
      },
      {
        FeatureCode: "T2",  //  特集コード
        FeatureName: "取引先協賛企画",  // 特集名
      },
      {
        FeatureCode: "T3",  //  特集コード
        FeatureName: "取引先協賛企画",  // 特集名
      },
    ],
  },
};

const featureList = {
  T1: "取引先協賛企画1",
  T2: "取引先協賛企画2",
  T3: "取引先協賛企画3",
}

function generateFeatureGoodsList(index: number) {
  const randomCode = ["T1", "T2", "T3"][Math.floor(Math.random() * 3)];
  const featureName = featureList[randomCode];

  return {
    OrderCode: "2023340",
    MediumType: "001",
    FeatureCode: randomCode,
    FeatureName: featureName,
    BuyerNotice: "バイヤー向け連絡事項",
    SupplierCode: "XXXXXX",
    SupplierName: "取引先名",
    PCode: "P" + PlessViewUtilsSub.zeroPadding(7, Math.floor(Math.random() * 10000000).toString()),
    GuideGoodsName: "商品案内用商品名",
    JanCode: "XXXXXXXXXXXXX",
    ItemCode: "1234567",
    GuideStandardName: "商品案内用規格名",
    MakerName: "メーカー名",
    SupplyPriceStandard: "XXXXXXX",
    SupplyPrice: "XXXXXXX",
    CostPriceStandard: "XXXXXXXXX",
    CostPrice: "XXXXXXXXX",
    StockNum: (Math.floor(Math.random() * 500) + 1).toString(),
    OrderUnitType: (Math.floor(Math.random() * 2)).toString(),
    NewUnitType: (Math.floor(Math.random() * 2)).toString(),
    PricePattern: (Math.floor(Math.random() * 4)).toString(),
    Remarks: "備考",
    ReplacementStatus: Math.floor(Math.random() * 10) % 2 === 0 ? '2' : '1',
    SelectorType: 1
  };
}

function featureGoodsListResponse(page: number, total: number) {
  const perPage = 100;
  const startDispNum = (page - 1) * perPage + 1;
  const endDispNum = Math.min(page * perPage, total);
  const list = Array.from({ length:endDispNum - startDispNum + 1 }, (_, i) => generateFeatureGoodsList(i + 1));

  return {
    status: 'ok',
    message: '処理完了',
    result: {
      obj: {
        // 特集商品提案状況一覧
        TotalNum: total.toString(),
        StartDispNum: startDispNum.toString(),
        EndDispNum: endDispNum.toString(),
        FeatureGoodsList: list,
      },
    },
  }
}

const getFeatureGoodsResponse = featureGoodsListResponse(1, 10);

const updateFeatureGoodsList = {
  status: 'ok',
  message: '処理完了',
};
